import { Box } from "@mui/material";
import { useGetOrderCommentsQuery } from "app/api/orders";
import { useOrderContext } from "context/OrderContext";
import LoadingDisplay from "components/LoadingDisplay";
import ErrorDisplay from "components/ErrorDisplay";
import EmptyMessage from "components/EmptyMessage";
import WorkDescriptionComment from "./WorkDescriptionComment";

const WorkDescriptionSection: React.FC = () => {
  const order = useOrderContext();
  const { data: comments, isLoading, isError } = useGetOrderCommentsQuery(order.ordernr);

  return (
    <Box p={1}>
      {isLoading ? (
        <LoadingDisplay message="Hämtar arbetsbeskrivning..." />
      ) : isError ? (
        <ErrorDisplay message="Kunde inte hämta arbetsbeskrivning" />
      ) : !comments?.length ? (
        <EmptyMessage m={1}>Ingen arbetsbeskrivning</EmptyMessage>
      ) : (
        <Box sx={{ display: "grid", gap: 1 }}>
          {comments.map((comment, index) => (
            <WorkDescriptionComment
              key={`${comment.type}-${comment.info}-${index}`}
              comment={comment}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default WorkDescriptionSection;
